import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import MainBody from "../components/layout/MainBody";
// Team section hidden for now — re-enable by uncommenting the import and
// the <TeamSection /> tag below.
// import TeamSection from "./TeamSection";

const About = () => {
  const topDescription =
    "Cross Vision Development Studios offers software engineering for all of your custom software needs. Our engineers have a combined 40 years of experience designing, building, deploying, and maintaining custom applications and software solutions.";

  const secondDescription =
    "Whether you need an application built from the ground up or new features added to existing software, we can develop for web, mobile, or desktop and deploy it securely. We have expertise in JavaScript, React, React Native, Swift, Java, C#, Python, PHP, Flask, and many more languages, frameworks, and technology stacks.";

  const values = [
    {
      id: 0,
      title: "Design",
      text: "We work with you to shape your idea into a clear, buildable product plan.",
    },
    {
      id: 1,
      title: "Build",
      text: "Experienced engineers write clean, maintainable code across the full stack.",
    },
    {
      id: 2,
      title: "Deploy",
      text: "We ship your software securely — to the web, the app stores, or both.",
    },
    {
      id: 3,
      title: "Maintain",
      text: "We stay with you after launch with hosting, updates, and support.",
    },
  ];

  return (
    <>
      <MainBody>
        <Container>
          <Row className="mb-4">
            <h1 style={styles.title}>Design, Build, Deploy &amp; Maintain</h1>
          </Row>
          <Row className="justify-content-center">
            <Col xs={12} lg={8}>
              <p style={styles.description}>{topDescription}</p>
              <p style={styles.description}>{secondDescription}</p>
            </Col>
          </Row>
        </Container>
      </MainBody>
      <Container fluid style={styles.container}>
        <Container>
          <Row className="mb-5">
            {values.map((item) => (
              <Col key={item.id} xs={12} md={3} className="mb-4 mb-md-0">
                <div style={styles.valueCard}>
                  <p style={styles.valueNumber}>{`0${item.id + 1}`}</p>
                  <h3 style={styles.valueTitle}>{item.title}</h3>
                  <p style={styles.valueText}>{item.text}</p>
                </div>
              </Col>
            ))}
          </Row>
          <Row className="text-center mt-5">
            <Col>
              <h3 style={styles.ctaTitle}>
                Have a great idea for an application?
              </h3>
              <p style={styles.ctaSubtitle}>We can build it for you.</p>
              <Button variant="primary" size="lg" as={Link} to="/contact">
                Get in touch
              </Button>
            </Col>
          </Row>
          {/* <TeamSection /> */}
        </Container>
      </Container>
    </>
  );
};

export default About;

const styles = {
  container: {
    backgroundColor: "#000",
    paddingTop: 100,
    paddingBottom: 100,
  },
  ctaSubtitle: {
    color: "#ACACAC",
    fontSize: 22,
    marginBottom: 24,
  },
  ctaTitle: {
    color: "#FFF",
    fontSize: 32,
    fontWeight: 700,
    marginBottom: 8,
  },
  description: {
    color: "#FFF",
    fontSize: 20,
    fontWeight: 500,
    lineHeight: 1.7,
    textShadow: "0 1px 8px rgba(0, 0, 0, 0.8)",
  },
  title: {
    color: "#FFF",
    fontWeight: 800,
    textShadow: "0 2px 12px rgba(0, 0, 0, 0.8)",
  },
  valueCard: {
    backgroundColor: "#1C1816",
    border: "1px solid #2E2925",
    borderRadius: 12,
    padding: 24,
    height: "100%",
    textAlign: "left",
  },
  valueNumber: {
    color: "#CF3620",
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: 2,
    marginBottom: 8,
  },
  valueText: {
    color: "#ACACAC",
    fontSize: 15,
    lineHeight: 1.6,
    marginBottom: 0,
  },
  valueTitle: {
    color: "#FFF",
    fontSize: 22,
    fontWeight: 600,
    marginBottom: 10,
  },
};
